/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_NotesInputs */

const en_options_quicktools_notes = /** @type {(inputs: Options_Quicktools_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const fr_options_quicktools_notes = /** @type {(inputs: Options_Quicktools_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const de_options_quicktools_notes = /** @type {(inputs: Options_Quicktools_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmerkungen`)
};

const it_options_quicktools_notes = /** @type {(inputs: Options_Quicktools_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

const ru_options_quicktools_notes = /** @type {(inputs: Options_Quicktools_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примечания`)
};

const es_options_quicktools_notes = /** @type {(inputs: Options_Quicktools_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas`)
};

const zh_cn2_options_quicktools_notes = /** @type {(inputs: Options_Quicktools_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`笔记`)
};

const ja_options_quicktools_notes = /** @type {(inputs: Options_Quicktools_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注記`)
};

const hi_options_quicktools_notes = /** @type {(inputs: Options_Quicktools_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नोट्स`)
};

const pt_pt2_options_quicktools_notes = /** @type {(inputs: Options_Quicktools_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Options_Quicktools_NotesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_notes = /** @type {((inputs?: Options_Quicktools_NotesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_NotesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_quicktools_notes(inputs)
	if (locale === "de") return de_options_quicktools_notes(inputs)
	if (locale === "it") return it_options_quicktools_notes(inputs)
	if (locale === "ru") return ru_options_quicktools_notes(inputs)
	if (locale === "es") return es_options_quicktools_notes(inputs)
	if (locale === "zh-CN") return zh_cn2_options_quicktools_notes(inputs)
	if (locale === "ja") return ja_options_quicktools_notes(inputs)
	if (locale === "hi") return hi_options_quicktools_notes(inputs)
	if (locale === "pt-PT") return pt_pt2_options_quicktools_notes(inputs)
	return en_options_quicktools_notes(inputs)
});